import axios from "axios";

axios.defaults.withCredentials = true;

export default
{
    async saveDepotPiece(situationFamiliale)
    {
        var dataFile = new FormData();
        situationFamiliale.nameFile.forEach(file => dataFile.append("file",file,file.name));
        situationFamiliale.nameFile.forEach(file => dataFile.append("types",file.code));
        var exportSituationFamilialeString = JSON.stringify(situationFamiliale);
        var exportSituationFamiliale = JSON.parse(exportSituationFamilialeString);
        exportSituationFamiliale.nameFile = situationFamiliale.nameFile.name;
        dataFile.append("depotPiece", JSON.stringify(exportSituationFamiliale));
        const changementSituationFamiliale = await axios.post(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE,dataFile,
            {
                "content-type": "multipart/form-data",
            }
            );
        return changementSituationFamiliale.data;
    },

    async saveAdresse(adresse)
    {
      const changementSituationFamiliale = await axios.post(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE,adresse,
        );
    return changementSituationFamiliale.data;
    },

    async getDemandesGestionnaire()
    {
        const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/drh/forGestionnaire");
        return demandes.data;
    },

    async getDemandesGestionnairesPIECE()
    {
        const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE_PIECE);
        return demandes.data;
    },

    async getDemandesGestionnaireByUid(uid)
    {
        const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/drh/forGestionnaire/" + uid);
        return demandes.data;
    },

    async getDemandeFileDRH(idFile)
    {
        return process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_FILE_DEPOT_PIECE_DRH + idFile;
    },

    async getDemandeFileAgent(idFile)
    {
        return process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_FILE_DEPOT_PIECE_AGENT + idFile;
    },

    async updateDemande(situationFamiliale)
    {
        return (await axios.put(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/drh",situationFamiliale, {"content-type" : "application/json"})).data;
    },

    async getDemandesByType(type)
    {
        return (await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/" + type)).data;
    },

    async getDemandesGestionnaireByType(type)
    {
      const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/drh/forGestionnaire/" + type);
      return demandes.data;
    },

    async getDemandesGestionnaireByTypeAndUid(type, uid)
    {
      const demandes = await axios.get(process.env.VUE_APP_BACKEND_API_URL + process.env.VUE_APP_URL_DEPOT_PIECE + "/drh/forGestionnaire/" + type + "/" + uid);
      return demandes.data;
    },

    async getDemandeFileDRH(idFile, temoin) {
      return  process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_FILE_DEPOT_PIECE_DRH +
        idFile + "/" + temoin;
    },

    async getDemandeFileAgent(idFile, temoin) {
      return  process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_FILE_DEPOT_PIECE_AGENT +
        idFile + "/" + temoin;
    },
}
